import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-6" data-testid="error-boundary">
          <div className="max-w-md text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center">
              <AlertTriangle className="h-8 w-8 text-red-500" strokeWidth={1.5} />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-black">Er ging iets mis</h1>
              <p className="text-sm text-neutral-500 mt-2">
                Er is een onverwachte fout opgetreden. Probeer de pagina te vernieuwen of ga terug naar het dashboard.
              </p>
            </div>
            <div className="flex justify-center gap-3">
              <Button variant="outline" onClick={this.handleRetry} data-testid="error-retry-btn">
                <RefreshCw className="h-4 w-4 mr-1.5" strokeWidth={1.5} />
                Opnieuw proberen
              </Button>
              <Button className="bg-black text-white hover:bg-neutral-800" onClick={this.handleGoHome} data-testid="error-home-btn">
                <Home className="h-4 w-4 mr-1.5" strokeWidth={1.5} />
                Naar dashboard
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
